import { FileUploadRequest, FileActions } from "@/business/files/domain/files";
import { loadInvoiceService } from "@/business/files/infrastructure/services/loadInvoiceService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const loadInvoice = {
    async execute(file: File): Promise<void> {
        const request: FileUploadRequest =
            FileActions().uploadFileRequest(
                file
            );
        await loadInvoiceService.execute(await tokenValidation.execute(), request);
    },
};